export const SET_COLUMNS = 'session/SET_COLUMNS';
export function setColumns(columns) {
  return { columns, type: SET_COLUMNS };
}

export const SET_CURRENT_PERSON_COLUMNS = 'session/SET_CURRENT_PERSON_COLUMNS';
export function setCurrentPersonColumns(columns) {
  return { type: SET_CURRENT_PERSON_COLUMNS, columns };
}

export const SET_CURRENT_COMPANY_COLUMNS = 'session/SET_CURRENT_COMPANY_COLUMNS';
export function setCurrentCompanyColumns(columns) {
  return { type: SET_CURRENT_COMPANY_COLUMNS, columns };
}
